var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFitToPlate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6558 16.6947H4.92781V8.43738L6.64381 6.88895H18.6558V16.6947ZM6.64381 15.1462H8.35981V13.5978H6.64381V15.1462ZM9.50413 15.1462H11.2201V13.5978H9.50413V15.1462ZM12.3635 15.1462H14.0795V13.5978H12.3635V15.1462ZM15.2238 13.5978V15.1462H16.9398V13.5978H15.2238ZM6.64381 12.5655H8.35981V11.0181H6.64381V12.5655ZM9.50413 12.5655H11.2201V11.0181H9.50413V12.5655ZM12.3635 12.5655H14.0795V11.0181H12.3635V12.5655ZM15.2238 12.5655H16.9398V11.0181H15.2238V12.5655ZM6.64381 9.9858H8.35981V8.43738H6.64381V9.9858ZM9.50413 9.9858H11.2201V8.43738H9.50413V9.9858ZM12.3635 9.9858H14.0795V8.43738H12.3635V9.9858ZM15.2238 9.9858H16.9398V8.43738H15.2238V9.9858Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.52108 5.64124L5.74524 5.74524L5.64124 2.52108L4.66619 3.49613L2.17006 1L1 2.17006L3.49613 4.66619L2.52108 5.64124Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4789 18.3588L18.2548 18.2548L18.3588 21.4789L19.3338 20.5039L21.8299 23L23 21.8299L20.5039 19.3338L21.4789 18.3588Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4789 5.64124L18.2548 5.74524L18.3588 2.52108L19.3338 3.49613L21.8299 1L23 2.17006L20.5039 4.66619L21.4789 5.64124Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.52108 18.3588L5.74524 18.2548L5.64124 21.4789L4.66619 20.5039L2.17006 23L1 21.8299L3.49613 19.3338L2.52108 18.3588Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFitToPlate);
export default __webpack_public_path__ + "static/media/FitToPlate.26ebd9b55f0b8a9ce9738d424b8b38a3.svg";
export { ForwardRef as ReactComponent };